// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sPaQ2k5YqzMLjdQwnNBM,.sPaQ2k5YqzMLjdQwnNBM>div{height:100%;overflow:hidden}.xb7IT_ZMUknAzBFEZDFO{overflow:initial;height:auto}.xb7IT_ZMUknAzBFEZDFO>div{overflow:initial;background:0 0;height:auto}.xb7IT_ZMUknAzBFEZDFO>div>div>div{background:0 0!important;border-bottom:none!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `sPaQ2k5YqzMLjdQwnNBM`,
	"wrap--collapse": `xb7IT_ZMUknAzBFEZDFO`,
	"wrapCollapse": `xb7IT_ZMUknAzBFEZDFO`
};
export default ___CSS_LOADER_EXPORT___;
